import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';

export const Layout = () => {
  return (
    <>
      <PXTextModalWrapper>
        <MetaControlField attr={'description'} />
      </PXTextModalWrapper>
      <MetaControlField attr={'disclosure'} />
    </>
  );
};

Layout.propTypes = {
};

Layout.defaultProps = {
};
